import type { ArrayElement } from '~/_shared/utils/array/array.helpers';

export const EXPORT_REPORT_BOUNDARY_GROUP_CODENAME = 'ags-us-zip-codes';

export const AGS_EXPORT_REPORT_COUNTRIES = ['usa', 'can', 'mex'] as const;

export type AgsReportCountry = ArrayElement<typeof AGS_EXPORT_REPORT_COUNTRIES>;

export const AGS_REPORT_COUNTRY_DEFAULT: AgsReportCountry = 'usa';
